export function isNestedArchiveFilePreviewKey(previewKey) {
    const nestedArchiveFilePreviewKey = previewKey.type === 'NestedArchiveFile' ? previewKey : null;
    return Boolean(nestedArchiveFilePreviewKey);
}
/**
 * Used to create an appropriately-structured PreviewKey
 * The nsId and sjId arguments are required to ensure that they are supplied if available,
 * since otherwise it would be easily to forget and use the FileId-only key when a specific revision is being viewed.
 */
function getPreviewKeyInternal(fileId, nsId, sjId, url) {
    const serialized = (fileId ? `fileId:[${fileId}]` : '') +
        (nsId ? `nsId:[${nsId}]` : '') +
        (sjId ? `sjId:[${sjId}]` : '') +
        (url ? `url:[${url}]` : '');
    /* eslint-disable @typescript-eslint/naming-convention */
    return {
        type: 'File',
        _fileId: fileId,
        _nsId: nsId,
        _sjId: sjId,
        _url: url,
        serialized,
    };
    /* eslint-enable @typescript-eslint/naming-convention */
}
export function getPreviewKeyForNestedArchiveFile(rootFileId, subpath) {
    return {
        type: 'NestedArchiveFile',
        rootFileId,
        subpath,
        serialized: `rootFileId:[${rootFileId}]subpath:[${subpath}]`,
    };
}
export function getPreviewKeyFromFileInfo(fileInfo) {
    return getPreviewKeyInternal(fileInfo.file_id, fileInfo.ns_id, fileInfo.sj_id, fileInfo.url);
}
//# sourceMappingURL=preview_key.preenvesnextjs.map
